class PayAppService {
  constructor() {
    this.userId = process.env.REACT_APP_PAYAPP_USER_ID;
    this.linkKey = process.env.REACT_APP_PAYAPP_LINK_KEY;
    this.linkValue = process.env.REACT_APP_PAYAPP_LINK_VALUE;
    this.baseUrl = process.env.REACT_APP_BASE_URL || 'https://www.onelinepaper.com';
  }

  // PayApp 결제 링크 생성
  async createPaymentLink(amount, points, userEmail = null) {
    try {
      // 로그인한 사용자의 이메일 가져오기
      if (!userEmail) {
        try {
          const supabaseService = (await import('./supabaseService')).default;
          const currentUser = supabaseService.getCurrentUser();
          userEmail = currentUser ? currentUser.email : null;
        } catch (error) {
          console.error('사용자 이메일 조회 실패:', error);
        }
      }
      
      const paymentData = {
        user_id: this.userId,
        amount: amount,
        points: points,
        user_email: userEmail, // 사용자 이메일 추가
        return_url: `${this.baseUrl}/payment/success`,
        cancel_url: `${this.baseUrl}/payment/cancel`,
        description: `One-Line Paper 포인트 충전 (${points.toLocaleString()}P)`
      };

      // Vercel API 라우트 호출
      const response = await fetch('/api/payapp/payment/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(paymentData)
      });

      if (!response.ok) {
        throw new Error(`PayApp API 오류: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('PayApp 결제 링크 생성 실패:', error);
      throw error;
    }
  }

  // 결제 상태 확인
  async verifyPayment(paymentId) {
    try {
      const response = await fetch(`/api/payapp/payment/verify/${paymentId}`, {
        method: 'GET'
      });

      if (!response.ok) {
        throw new Error(`결제 확인 실패: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('결제 확인 실패:', error);
      throw error;
    }
  }

  // 포인트 충전 처리
  async processPayment(paymentId, userId, points) {
    try {
      // 결제 확인 - PayApp은 state='1'이 성공
      const payment = await this.verifyPayment(paymentId);
      
      if (payment.state === '1') {
        // 포인트 지급
        const pointsService = (await import('./pointsService')).default;
        pointsService.addCurrentPoints(points, 'PayApp 충전');
        
        // Supabase에 동기화
        await pointsService.syncPointsToSupabase();
        
        return {
          success: true,
          points: points,
          paymentId: paymentId,
          verified: true
        };
      } else {
        throw new Error('결제가 완료되지 않았거나 검증되지 않았습니다.');
      }
    } catch (error) {
      console.error('포인트 충전 처리 실패:', error);
      throw error;
    }
  }

  // 충전 옵션 가져오기
  getChargeOptions() {
    return [
      {
        id: 'charge_5000',
        amount: 5000,
        points: 5000,
        label: '5,000원 → 5,000포인트',
        description: '기본 충전'
      },
      {
        id: 'charge_10000',
        amount: 10000,
        points: 10000,
        label: '10,000원 → 10,000포인트',
        description: '추천 충전'
      }
    ];
  }
}

const payappService = new PayAppService();
export default payappService;
